import { DHUserMode } from '@app/code/src/types/design-huddle.types'
import { DesignHuddleProvider } from '@app/code/src/components/PrintStoreTemplates/DesignHuddle/context'
import { EditTemplatePage } from '@app/code/src/components/PrintStoreTemplates/EditTemplatePage/EditTemplatePage'
import { FC } from 'react'
import { PageContainer } from '../../../../components/layout'
import { PrintStoreContainer } from '@app/code/src/containers/print-store/PrintStoreContainer'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { useNavigationRoutes } from '../../../../hooks/useNavigationRoutes'
import { useRedirectOnAuthChanges } from '@dtx-company/inter-app/src/hooks/auth/useRedirectOnAuthChanges'

const PrintStoreEditTemplatePage: FC = () => {
  const { shouldShowLeftNav } = useNavigationRoutes()

  useRedirectOnAuthChanges(true)

  return (
    <PageContainer
      hideContentIfLoggedOut
      page={Routes.PRINT_STORE_EDIT_TEMPLATE}
      disableSideNav={!shouldShowLeftNav}
      disableFooter
    >
      <PrintStoreContainer>
        <DesignHuddleProvider mode={DHUserMode.GUEST}>
          <EditTemplatePage />
        </DesignHuddleProvider>
      </PrintStoreContainer>
    </PageContainer>
  )
}

export default PrintStoreEditTemplatePage
